module.exports = __webpack_public_path__ + "static/media/image (10).ee003083.jpg";